
import React, { Fragment, useContext, useRef } from 'react';

// contexts
import { UserContext } from "../../Contexts/UserContext/UserContext.js";
import SwapBotContext from '../../Contexts/SwapBotContext.js';
import RunContext from '../../Contexts/RunContext.js';
// hooks
import useLog from '../../hooks/useLog.js';
import useTxSender, { reload_token_balance_andHistory } from '../../hooks/useTxSender.js';
// components
import { Row } from "../../components/Row";
import { Spaces } from "../../components/Spaces";
import { TextDisplay } from "../../components/TextDisplay/TextDisplay";
import { Tableau } from "../../components/Tableau";
import SuccessTxSender from '../../components/SuccessTxSender.js';
import SoldeBSV from '../../components/SoldeBSV.js';
import SoldeToken from '../../components/SoldeToken.js';
import SkeletonText from '../../components/SkeletonText.js';
// other
import { default_func_jsx_fail } from '../../helpers/helpers.js';
import { MouseOverPopover } from '../../components/MouseOverPopover.js';
import { sats_to_bsv } from "../../helpers/convert_bsv_tokens.js"
import { Alert } from 'react-bootstrap';
import { getLog, timestamp_to_ms } from '../../helpers/helpers.js';



/**
 * converts a list of admin_requests to table_values ready to inject in a Tableau component
 * 
 * args: 
 * 		- admin_requests: 			list
 * 		- send_bsv_to_user			func
 * 		- refund_tokens_to_user		func
 */
function admin_requests_to_table_values(
	admin_requests, dict_sell_button_style, base_price, total_mult,
	decimals, BSVEUR, send_bsv_to_user, refund_tokens_to_user, run
) {
	const function_id = "admin_requests_to_table_values(): "
	const log = getLog(function_id)
	let table_values = []

	if (admin_requests && admin_requests.length > 0) {
		for (let i = 0; i < admin_requests.length; i++) {
			const admin_request = admin_requests[i]

			// date

			// note: for sell_requests the oracle timestamp is only to improve timestamp precision, it is NOT a certainty that the oracle did answer it

			let timestamp_oracle_val = admin_request.get_timestamp()
			let timestamp_cache_user_request = run.cache.get("time://" + admin_request.location.split('_')[0])
			if (!timestamp_cache_user_request) timestamp_cache_user_request = run.cache.get("time://" + admin_request.location)
			let timestamp = timestamp_oracle_val || timestamp_cache_user_request
			timestamp = timestamp_to_ms(timestamp)


			log("", admin_request.location,
				"\n timestamp_oracle_val=", timestamp_oracle_val,
				"\n timestamp_cache_user_request=", timestamp_cache_user_request
			)
			// try another way ? unsure this works (update: doesn't seem valid so commenting for now)
			// var timestamp_backup = tryAccessProperty(()=>admin_request.caller.caller.oracle_Timestamp.value)
			// if(!timestamp && timestamp_backup) timestamp = timestamp_backup

			let date_unset = "inconnue"

			let date = date_unset
			if (timestamp && !isNaN(timestamp)) {
				date = new Date(timestamp).toLocaleString("fr-FR", { hour12: false })
			}

			// bsveur (interesting for paid ones)

			// TODO check potential risk on BSVEUR // search: glker54654e4
			// we should fix the base_price or bsveur in the admin's "pay_bsv()" action of the contract,
			// otherwise it is very hard to calculate the EUR value sent once we update the base_price 

			let bsveur_jsx = (BSVEUR).toFixed(2) + " €"

			// nb_tokens

			// value of tokens to send pre-mult
			let tokens_amount = admin_request.amount_to_send // this is safe as long as the send() is hardcoded in the contract with .amount_to_send

			let nb_tokens = 0, EUR_to_pay = 0, EUR_to_pay_jsx = "-"
			if (admin_request.refund_nb_tokens) { // was refund already, compute with locked-in historical values
				nb_tokens = admin_request.refund_nb_tokens
				bsveur_jsx = "-"
				// .refund_base_price is put by admins & then only can be retrieved
				if (admin_request.refund_base_price) {
					EUR_to_pay = admin_request.refund_base_price * nb_tokens // already in EUR
				} else EUR_to_pay = nb_tokens * base_price
			}
			else if (admin_request.paid_satoshis) { // was paid by admins => compute with locked-in historical values
				nb_tokens = admin_request.paid_for_nb_tokens
				EUR_to_pay = sats_to_bsv(admin_request.paid_satoshis) * admin_request.paid_bsveur
			}
			else {  // still pending => compute with current mults & base_price
				// toFixed(0) does: 0.99=>"1" , 1.01=>"1", very important before parseInt !
				nb_tokens = parseInt((
					tokens_amount * total_mult / Math.pow(10, decimals)
				).toFixed(0))
				EUR_to_pay = nb_tokens * base_price
			}
			if (EUR_to_pay) EUR_to_pay_jsx = (EUR_to_pay).toFixed(2) + " €"

			// todo comment this logging once everything works fine
			log("admin_request ", admin_request.location,
				"\n nb_tokens=", nb_tokens,
				"\n EUR_to_pay=", EUR_to_pay,
				"\n !!admin_request.refund_nb_tokens=", !!admin_request.refund_nb_tokens,
				"\n (otherwise: base_price=", base_price, "total_mult=", total_mult, "decimals=", decimals, ")",
				"\n admin_request=", admin_request)

			// status_jsx

			var status = admin_request.status
			var status_url_location = admin_request.location // default, better than nothing
			var status_jsx = status

			var is_completed = false
			if (status !== "pending") {
				is_completed = true
			}

			// translate status
			if (status === "paid") {
				status_jsx = "payé"
				// TODO get url pointing to payment tx
			}
			else if (status === "refunded") {
				status_jsx = "remboursé"
				// TODO get url pointing to refund tx
				// if(admin_request.BSV_Refund) {
				// 	status_url_location = admin_request.BSV_Refund.location 
				// }
			}
			else if (status === "pending") {
				status_jsx = "en attente"
			}

			var status_url = "https://whatsonchain.com/tx/" + status_url_location.split('_')[0]
			status_jsx =
				<a href={status_url} target="_blank" rel="noopener noreferrer" style={{ color: (is_completed ? "limegreen" : "orange") }}>
					{status_jsx}
				</a>

			// timestamp_completed / admin actions

			var timestamp_completed = (admin_request.cancel_timestamp || admin_request.paid_timestamp)

			var date_completed = date_unset
			var admin_actions = "--"
			if (is_completed) {
				date_completed = new Date(timestamp_completed).toLocaleString("fr-FR", { hour12: false })
			}
			else { // status==="pending"
				const request_location = admin_request.location // react needs this because of unsafe references
				// beware of the "no-loop-func" warning/bugs if you pass var to functions in JSX, they need to be const or let, not vars (wider scope breaks it)
				admin_actions =
					<Fragment>
						<button onClick={() => {
							send_bsv_to_user(
								request_location, EUR_to_pay, nb_tokens, base_price
							)
						}}
							className="button-main-style-red"
							style={{ ...dict_sell_button_style, marginRight: "5px" }}>
							&nbsp; Payer {EUR_to_pay}€ de BSV&nbsp;
						</button>
						<button onClick={() => { refund_tokens_to_user(request_location) }}
							className="blue-button-main-style"
							style={dict_sell_button_style}>
							Rembourser {nb_tokens} tokens
						</button>
					</Fragment>
			}

			// "Date", "Tokens", "Prix", "BSV/EUR", "Status", "Date"/"Actions"
			// "Date", "Tokens", "Prix BSV (a payer/payé)", "Status", "Date"/"Actions"
			var curr_data = [
				String(date),
				String(parseInt(nb_tokens)),
				EUR_to_pay_jsx,
				bsveur_jsx,
				status_jsx,
				(is_completed ? date_completed : admin_actions)
			]
			table_values.push(curr_data)
		}
	}
	return table_values
}


export function Slide_SwapBot_Ventes(props) {
	const function_id = "Slide_SwapBot_Ventes(): "
	// const classname = function_id
	const log = useLog(function_id)

	const tokenName = "Delphe"
	const tokenName_plural = tokenName + 's'

	// update delphetx_state based on txStateContext
	const tokenID = userContext.get_selected_coin_props().tokenid
	const tokenActionID = tokenID + "_admin_send_sold_tokens_or_refund" // todo make better, will need a dynamic one with txid in it for parallel sends

	const swapbotContext = useContext(SwapBotContext)
	const admin_sell_requests = swapbotContext.admin_sell_requests
	const base_price = swapbotContext.base_price

	const userContext = useContext(UserContext)
	const runContext = useContext(RunContext)
	const run = runContext.run

	const total_mult = userContext.total_mult
	const tokenoriginjig_decimals = userContext.tokenoriginjig_decimals

	let admin_sell_requests_pending = [], admin_sell_requests_completed = []
	if (admin_sell_requests != null) {
		admin_sell_requests_pending = admin_sell_requests.filter(e => e.get_status().includes("pending"))
		admin_sell_requests_completed = admin_sell_requests.filter(e => !e.get_status().includes("pending"))
	}

	log("\n admin_sell_requests_pending=", admin_sell_requests_pending,
		"\n admin_sell_requests_completed=", admin_sell_requests_completed)

	const BSVEUR = userContext.bsvprice
	const token_balance = userContext.tokens_balance[tokenID]
	const bool_context_has_loaded = (
		token_balance != null && admin_sell_requests != null && base_price != null && total_mult != null
		&& tokenoriginjig_decimals != null && BSVEUR != null
	)
	const has_loaded = bool_context_has_loaded //(admin_sell_requests!=null)

	const ref_messageEndRef = useRef(null) // for autoscroll


	log("\n total_mult=", total_mult,
		"\n tokenoriginjig_decimals=", tokenoriginjig_decimals,
		"\n BSVEUR=", BSVEUR)

	// --- FUNCTIONS ---

	async function func_empty_fields() { }
	const mess_default = "" //"Un récapitulatif des "+tokenName_plural+" à vendre va s'afficher ici"
	var jsx_loading = null //<LoaderWithMess mess={mess_default} />
	var jsx_recap = null

	const func_jsx_sending = (txstate) => {
		let sending_mess = <span>
			Sending {txstate.EUR_to_pay}€ of BSV...
		</span>

		if (txstate['type'] === "refund") {
			sending_mess = <span> Remboursement des {tokenName_plural} en cours... </span>
		}

		return (
			<Fragment>
				{sending_mess}&nbsp;
				<i className="reloadIcon fas fa-sync fa-spin" />
			</Fragment>
		)
	}

	const func_jsx_success = (txstate) => {
		let success_mess = <span>
			{txstate.EUR_to_pay}€ de BSV envoyés avec succès !
		</span>

		if (txstate['type'] === "refund") {
			success_mess = <span> {tokenName_plural} remboursés avec succès ! </span>
		}

		return (
			<SuccessTxSender txstate={txstate}>
				{success_mess}
			</SuccessTxSender>
		)
	}

	const func_onSuccess_once = () => {
		reload_token_balance_andHistory(userContext)
		swapbotContext.refresh_admin_sell_requests()
	}


	// --- HOOK useTxSender ---

	const array_bool_user_inputs = []

	const [
		bool_broadcast_lock,
		, // func_resetMess is useless in this slide
		dict_sell_button_style, // to use on all send buttons in this slide
		jsx_mess,
	]
		= useTxSender(
			tokenActionID,
			array_bool_user_inputs,
			bool_context_has_loaded,
			ref_messageEndRef,
			mess_default,
			jsx_loading,
			jsx_recap,
			func_jsx_sending,
			func_jsx_success,
			default_func_jsx_fail,
			func_empty_fields,
			func_onSuccess_once,
		)

	// --- FUNCTIONS ---

	function send_bsv_to_user(request_txid, EUR_to_pay, nb_tokens, base_price) {
		// don't allow parallel sends
		if (bool_broadcast_lock) {
			window.alert("Echec: une demande est déjà en cours d'envoi.")
			return
		}

		swapbotContext.send_bsv_to_user(tokenActionID, tokenName, request_txid, EUR_to_pay, nb_tokens, base_price)
	}

	function refund_tokens_to_user(request_location) {
		// don't allow parallel sends
		if (bool_broadcast_lock) {
			window.alert("Echec: une demande est déjà en cours d'envoi.")
			return
		}

		swapbotContext.refund_tokens_to_user(tokenActionID, tokenName, request_location)
	}

	// --- DISPLAY ---

	function _admin_requests_to_table_values(requests) {
		// inject required args
		return admin_requests_to_table_values(requests,
			dict_sell_button_style, base_price, total_mult, tokenoriginjig_decimals,
			BSVEUR, send_bsv_to_user, refund_tokens_to_user, run
		)
	}

	const table_values =
		// reverse to display oldest first
		_admin_requests_to_table_values(admin_sell_requests_pending.reverse())

	const table_values_completed =
		// no reverse to display newest first
		_admin_requests_to_table_values(admin_sell_requests_completed)

	const actions_title_jsx =
		<span style={{ display: "inline-flex" }}>
			Actions &nbsp;
			<MouseOverPopover
				contentjsx={<i className="fas fa-question-circle" />}
				popoverjsx={<Fragment>
					<b>Payer BSV</b> envoie les BSV au cours actuel<br />
					<b>Rembourser</b> renvoie les Delphes au client<br />
				</Fragment>}
			/>
		</span>

	const arrSum = arr => arr.reduce((a, b) => a + b, 0) // Math.sum(arr) equivalent

	function get_total_pending_mess_jsx() {
		let total_pending_amount = <SkeletonText width="4em" black />
		let total_pending_tokens = <SkeletonText width="4em" black />
		let total_pending_EURtoPay = <SkeletonText width="4em" black />
		if (admin_sell_requests != null) {
			total_pending_amount = arrSum(admin_sell_requests_pending.map(e => e.amount_to_send))
			total_pending_tokens = (total_pending_amount * total_mult / Math.pow(10, tokenoriginjig_decimals)).toFixed(2)
			total_pending_EURtoPay = (total_pending_tokens * base_price).toFixed(2)
		}
		return <span>Total:
			&nbsp;{total_pending_tokens} {tokenName_plural} à racheter pour
			&nbsp;{total_pending_EURtoPay} € de BSV
		</span>
	}

	let nb_pending_sell_requests_jsx = null
	if (admin_sell_requests != null) {
		nb_pending_sell_requests_jsx = admin_sell_requests_pending.length + " "
	}

	return (
		<div>
			<h1><i className="fas fa-hand-holding-usd" /><Spaces count="3" />
				Demandes de ventes
			</h1><br />

			<center>
				<SoldeToken />
				<br />
				<SoldeBSV />
				<br />
			</center>

			<Row>
				<h3 style={{ paddingRight: "10px" }}><i className="fas fa-clock" /><Spaces count="2" />
					{nb_pending_sell_requests_jsx} Ventes en attente
				</h3>
				{/* <div style={{margin:"13px"}}>
						<button onClick={this.sendAll} className="button-main-style-red"
							style={buy_all_style} >Envoyer Tout</button>  
					</div>
				*/}
			</Row>

			<Alert variant="light">{get_total_pending_mess_jsx()}</Alert>

			<center>
				<div ref={ref_messageEndRef}>
					{/* note: seems like the ref only works if it's NOT in some conditional rendering */}
					{jsx_mess ?
						<Row><TextDisplay>
							{jsx_mess}
						</TextDisplay></Row>
						: null}
				</div>
			</center>

			<Tableau
				titles={["Date", tokenName_plural, "BSV à payer", "BSV/EUR", "Status", actions_title_jsx]}
				values={table_values}
				empty_mess="Aucune demande en attente pour le moment."
				loading={!has_loaded}
			/>
			<br /><br /><br />

			<Row>
				<h4 style={{ paddingRight: "10px" }}>
					<i className="fas fa-clipboard-check" /><Spaces count="3" />
					Demandes de ventes complétées
				</h4>
			</Row>

			<Tableau
				titles={["Date", tokenName_plural, "BSV payé", "BSV/EUR", "Status", "Payé le"]}
				values={table_values_completed}
				empty_mess="Aucune demande complétée pour le moment."
				loading={!has_loaded}
			/>

		</div>
	)
}
